// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Otsls","content":"styles_content__3IQHf"};